import React from 'react';

import { Dialog, DialogContent, DialogTrigger } from '@shared/ui/modals';

import { TBankLoadingModalProps } from '../model/types';
import { Content } from './Content';

export const BankLoadingModal = ({
  open,
  destination,
  onOpenChange,
  triggerElement,
}: TBankLoadingModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {triggerElement && <DialogTrigger asChild>{triggerElement}</DialogTrigger>}
      <DialogContent className={` w-[350px]`}>
        <Content destination={destination} />
      </DialogContent>
    </Dialog>
  );
};
